import { TASKS_SERVICE_URL } from "@coworker/app/src/hooks/API/tasks.service.helper";
import { CreateTaskTypeDTO, TaskType } from "../types/TaskType";
import {
  createAuthorizationHeader,
  throwIfNotOk,
  toJson,
} from "@coworker/apprestructured/src/task-management/services/fetchHelper";

const NO_TASK_TYPES: TaskType[] = [];

export async function createTaskType(createTaskType: CreateTaskTypeDTO) {
  return toJson<TaskType>(
    await fetch(`${TASKS_SERVICE_URL}/task-types`, {
      method: "POST",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(createTaskType),
    })
  );
}

export async function getAllTaskTypes(): Promise<TaskType[]> {
  return toJson<TaskType[]>(
    await fetch(`${TASKS_SERVICE_URL}/task-types`, {
      method: "GET",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
    })
  );
}

export async function getTaskTypes(ids: string[]) {
  if (ids.length === 0) {
    return NO_TASK_TYPES;
  }

  return toJson<TaskType[]>(
    await fetch(`${TASKS_SERVICE_URL}/task-types/${ids.join(",")}`, {
      method: "GET",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
    })
  );
}

export async function updateTaskType(taskType: TaskType) {
  return toJson<TaskType>(
    await fetch(`${TASKS_SERVICE_URL}/task-types/${taskType.id}`, {
      method: "PUT",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(taskType),
    })
  );
}

export async function deleteTaskType(id: string) {
  throwIfNotOk(
    await fetch(`${TASKS_SERVICE_URL}/task-types/${id}`, {
      method: "DELETE",
      headers: {
        ...(await createAuthorizationHeader()),
      },
    })
  );
}
